export default __webpack_public_path__ + "static/media/logo_sotus.befb9ac0.png";